




































import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../../domain";
import { BrowserUtility, BrowserKinds } from "../../../../../../utilities";
import { ImelessTextarea } from "../../../../../system";
import { DialogMixin } from "../../../../../system/mixins";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class UnlockDialog extends Mixins(DialogMixin) {
  $refs!: {
    passwordImelessTextarea: ImelessTextarea,
    passwordInput: HTMLInputElement,
  };

  data(): any {
    return {
      password: "",
      isAuthenticating: false,
      result: false,
    };
  }
  password: string;
  isAuthenticating: boolean;
  result: boolean;

  get input(): HTMLElement {
    return this.shouldUseImelessTextarea ? this.$refs.passwordImelessTextarea.getEditor() : this.$refs.passwordInput;
  }

  get shouldUseImelessTextarea(): boolean {
    return (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer)
        && !BrowserUtility.isMobile()
        && !BrowserUtility.isTouchSupported();
  }

  get isAuthenticatable(): boolean {
    return this.password !== "" && !this.isAuthenticating;
  }

  async show(): Promise<boolean> {
    return this.showModal(async () => {
      this.result = false;
      this.password = "";
      this.$nextTick(() => {
        this.input.focus();
      });
      await this.waitHidden();
      return this.result;
    });
  }

  async authenticate(): Promise<void> {
    try {
      this.isAuthenticating = true;
      await DomainRegistry.instance.document.getAuthenticationService().authenticateWizardManagement(this.password);
      this.result = true;
      this.isVisible = false;
    } catch (e) {
      this.$warn(
        "解除失敗",
        "ロック解除失敗しました。解除コードを確認してください。",
      );
      this.password = "";
      this.input.focus();
    } finally {
      this.isAuthenticating = false;
    }
  }

  close(): void {
    this.isVisible = false;
  }
}
